import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Assessment from "@/pages/Assessment";

const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const AdminLive = lazy(() => import("@/pages/AdminLive"));
const SetPassword = lazy(() => import("@/pages/SetPassword"));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-upland-offwhite font-sans text-upland-grey">Loading…</div>
);

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <PageLoader />;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

// Cross-app hand-off from the main Upland site's "Open Specialized Assessments" button.
// Stashes the launch params, then routes into the admin (login-gated) to auto-start a live run.
function OaLaunch() {
  const [params] = useSearchParams();
  const data = {
    client: params.get("client") || "", email: params.get("email") || "",
    company: params.get("company") || "", user: params.get("user") || "", role: params.get("role") || "",
  };
  sessionStorage.setItem("oa_launch", JSON.stringify(data));
  return <Navigate to="/admin" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Assessment />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/oa" element={<OaLaunch />} />
            <Route path="/admin/set-password" element={<SetPassword />} />
            <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
            <Route path="/admin/live" element={<Protected><AdminLive /></Protected>} />
            <Route path="/admin/users" element={<Protected><AdminDashboard /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
